var render, staticRenderFns
import script from "./SourcesIndex.vue?vue&type=script&lang=js&"
export * from "./SourcesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/classleasingtraffic.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b119fec')) {
      api.createRecord('2b119fec', component.options)
    } else {
      api.reload('2b119fec', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/Backend/SourcesIndex.vue"
export default component.exports